import styled from "styled-components/macro";

export const StyledErrorTitle = styled.h2`
	font-weight: 600;
	font-size: 40px;
	line-height: 60px;

	color: #575e68;
`;
export const StyledErrorP = styled.p`
	font-size: 21px;
	line-height: 31px;
	text-align: center;

	color: #575e68;
`;

export const MenuWrapper = styled.div`
	position: relative;
	display: inline-block;
	width: 100%;
	height: 100%;
	cursor: pointer;
	div {
		display: ${(props) => (props.show ? "flex" : "none")};
		opacity: ${(props) => (props.show ? 1 : 0)};
	}
	z-index: 2;
`;
export const MenuContent = styled.div`
	background: #ffffff;
	box-shadow: 0px 4px 10px 0px #00000026;
	border: 1px solid #ebedee;
	border-radius: 8px;
	color: #3a5558;
	font-size: 12px;
	line-height: 18px;
	padding: 10px;
	flex-direction: column;
	place-items: start stretch;
	gap: 10px;
	position: absolute;
	z-index: 1;
	/* Position */
	top: 50%;
	left: 50%;
	transform: translate(-90%, 8%);

	/* Fade In  */
	opacity: 0;
	transition: opacity 0.3s;
`;
export const MenuLineButton = styled.button`
	background: none;
	color: inherit;
	border: none;
	font: inherit;
	cursor: pointer;
	outline: inherit;
	min-width: 120px;
	padding: 0.3rem;
	text-align: left;
	&:hover {
		font-weight: 600;
	}
`;
